@if (!iso) {
<empty>-</empty>
} @if (iso) {
<time [attr.datetime]="iso">{{ iso | date : 'short' : utcTimezone }}</time>
}
